import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ProjectService from "../ProjectService";
import Highcharts from "../point.extensions";
import HighchartsReact from "highcharts-react-official";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import {
  calculateDate,
  getTimeZoneName,
  getDecimalValue,
  checkAbsoluteValue,
} from "../../../config/helpingFunctions";
import computeDifferential from "./functions/DifferentialFilter";
import computeIntegration from "./functions/IntegrationFilter";

const EventReport = (): JSX.Element => {
  const { t } = useTranslation();

  const search = useLocation().search;
  const did = new URLSearchParams(search).get("did") as string;
  const strtDate = new URLSearchParams(search).get("str_time") as string;
  const edDate = new URLSearchParams(search).get("end_time") as string;
  const projectId = new URLSearchParams(search).get("projectId") as string;

  const projectService = new ProjectService();

  const [vectorSumData, setVectorSumData] = useState<any>([]);

  const [allData, setAllData] = useState<any>([]);

  const [isModalOpen, setIsModalOpen] = useState<boolean>(true);
  const [viewReport, setViewReport] = useState<boolean>(false);
  const [tableShown, setTableShown] = useState<boolean>(false);

  const [tablechecked, setTableChecked] = useState<boolean>(false);
  const [eventchecked, setEventChecked] = useState<boolean>(false);
  const [disable, setDisable] = useState<boolean>(true);

  const [stationName, setStationName] = useState<string>("");
  const [deviceName, setDeviceName] = useState<string>("");
  const [deviceId, setDeviceId] = useState<string>("");
  const [gpsPos, setGpsPos] = useState<string>("");
  const [strtTime, setStrtTime] = useState<any>("");
  const [edTime, setEndTime] = useState<any>("");

  const [xAxisUnit, setXAxisUnit] = useState<any>();
  const [yAxisUnit, setYAxisUnit] = useState<any>();
  const [zAxisUnit, setZAxisUnit] = useState<any>();

  const [maxX, setMaxX] = useState<number>();
  const [maxY, setMaxY] = useState<number>();
  const [maxZ, setMaxZ] = useState<number>();

  const [maxTimeX, setMaxTimeX] = useState<any>();
  const [maxTimeY, setMaxTimeY] = useState<any>();
  const [maxTimeZ, setMaxTimeZ] = useState<any>();

  const [frequenceX, setFrequenceX] = useState<number>();
  const [frequenceY, setFrequenceY] = useState<number>();
  const [frequenceZ, setFrequenceZ] = useState<number>();

  const [integrationX, setIntegrationX] = useState<any>();
  const [integrationY, setIntegrationY] = useState<any>();
  const [integrationZ, setIntegrationZ] = useState<any>();

  const [differentialX, setDifferentialX] = useState<any>();
  const [differentialY, setDifferentialY] = useState<any>();
  const [differentialZ, setDifferentialZ] = useState<any>();

  const [headerData, setHeaderData] = useState<any>({});

  const [xData, setXdata] = useState<any>([]);
  const [yData, setYdata] = useState<any>([]);
  const [zData, setZdata] = useState<any>([]);

  const [xPointData, setXPointdata] = useState<any>([]);
  const [yPointData, setYPointdata] = useState<any>([]);
  const [zPointData, setZPointdata] = useState<any>([]);

  const [xConfig, setxConfig] = useState<any>({
    title: {
      text: "",
    },
  });
  const [yConfig, setyConfig] = useState<any>({
    title: {
      text: "",
    },
  });
  const [zConfig, setzConfig] = useState<any>({
    title: {
      text: "",
    },
  });

  const [vectorConfig, setvectorConfig] = useState<any>({
    title: {
      text: "Relative Time in [s]",
    },
  });

  const graph_x = {
    credits: {
      enabled: false,
    },
    boost: {
      useGPUTranslations: true,
      // Chart-level boost when there are more than 5 series in the chart
      seriesThreshold: 5,
    },
    chart: {
      zoomType: "x",
      height: 180,
      width: 900,
    },
    tooltip: {
      valueDecimals: 2,
    },
    xAxis: {
      labels: { enabled: false },
      ...JSON.parse(JSON.stringify(xConfig)),
    },
    yAxis: {
      title: {
        // text: xAxisUnit,
      },
    },
    title: {
      text: "X-Axis Graph",
    },
    subtitle: {
      text: "",
    },
    series: [
      {
        data: xData,
        showInLegend: false,
        name: "Amplitude mm/s ",
      },
    ],
  };

  const graph_y = {
    credits: {
      enabled: false,
    },
    boost: {
      useGPUTranslations: true,
      // Chart-level boost when there are more than 5 series in the chart
      seriesThreshold: 5,
    },
    chart: {
      zoomType: "x",
      height: 180,
      width: 900,
    },

    tooltip: {
      valueDecimals: 2,
    },
    xAxis: {
      labels: { enabled: false },
      ...JSON.parse(JSON.stringify(yConfig)),
    },
    yAxis: {
      title: {
        // text: yAxisUnit,
      },
    },
    title: {
      text: "Y-Axis Graph",
    },
    subtitle: {
      text: "",
    },
    series: [
      {
        data: yData,
        showInLegend: false,
        name: "Amplitude mm/s ",
      },
    ],
  };

  const graph_z = {
    credits: {
      enabled: false,
    },
    boost: {
      useGPUTranslations: true,
      // Chart-level boost when there are more than 5 series in the chart
      seriesThreshold: 5,
    },
    chart: {
      zoomType: "x",
      height: 180,
      width: 900,
    },

    tooltip: {
      valueDecimals: 2,
    },
    xAxis: {
      crosshair: true,
      labels: { enabled: false },
      ...JSON.parse(JSON.stringify(zConfig)),
    },
    yAxis: {
      title: {
        // text: zAxisUnit,
      },
    },
    title: {
      text: "Z-Axis Graph",
    },
    subtitle: {
      text: "",
    },
    series: [
      {
        data: zData,
        showInLegend: false,
        name: "Amplitude mm/s ",
      },
    ],
  };

  const vector_sum_graph = {
    credits: {
      enabled: false,
    },
    boost: {
      useGPUTranslations: true,
      // Chart-level boost when there are more than 5 series in the chart
      seriesThreshold: 5,
    },
    chart: {
      zoomType: "x",
      height: 180,
      width: 900,
    },

    tooltip: {
      valueDecimals: 2,
    },
    xAxis: {
      crosshair: true,
      ...JSON.parse(JSON.stringify(vectorConfig)),
    },
    yAxis: {
      title: {
        // text: zAxisUnit,
      },
    },
    title: {
      text: "Vector Sum Graph",
    },
    subtitle: {
      text: "",
    },
    series: [
      {
        data: vectorSumData,
        showInLegend: false,
        name: "Amplitude mm/s ",
      },
    ],
  };

  const xpointGraph = {
    credits: {
      enabled: false,
    },
    boost: {
      useGPUTranslations: true,
      // Chart-level boost when there are more than 5 series in the chart
      seriesThreshold: 5,
    },
    chart: {
      type: "scatter",
      zoomType: "xy",
      // height: 180,
      width: 900,
    },
    title: {
      text: "X-Axis Event Graph",
    },
    tooltip: {
      valueDecimals: 2,
    },
    xAxis: {
      title: {
        text: "",
      },
      type: "datetime",
    },
    yAxis: {
      title: {
        text: "mm/s",
      },
    },
    plotOptions: {
      scatter: {
        marker: {
          radius: 5,
          states: {
            hover: {
              enabled: false,
              //   lineColor: 'rgb(100,100,100)'
            },
          },
        },
      },
    },
    series: [
      {
        name: "X",
        // color: "rgb(177, 205, 233)",
        data: xPointData,
        tooltip: {
          crosshairs: true,
          pointFormat:
            "x: <b>{point.x:%e:%b%Y %H:%M:%S:%L}</b><br/>y: <b>{point.y}</b><br/>",
        },
      },
    ],
  };

  const ypointGraph = {
    credits: {
      enabled: false,
    },
    boost: {
      useGPUTranslations: true,
      // Chart-level boost when there are more than 5 series in the chart
      seriesThreshold: 5,
    },
    chart: {
      type: "scatter",
      zoomType: "xy",
      // height: 180,
      width: 900,
    },
    title: {
      text: "Y-Axis Event Graph",
    },
    tooltip: {
      valueDecimals: 2,
    },
    xAxis: {
      title: {
        text: "",
      },
      type: "datetime",
    },
    yAxis: {
      title: {
        text: "mm/s",
      },
    },
    plotOptions: {
      scatter: {
        marker: {
          radius: 5,
          states: {
            hover: {
              enabled: false,
              //   lineColor: 'rgb(100,100,100)'
            },
          },
        },
      },
    },
    series: [
      {
        name: "Y",
        // color: "rgb(177, 205, 233)",
        data: yPointData,
        tooltip: {
          crosshairs: true,
          pointFormat:
            "x: <b>{point.x:%e:%b%Y %H:%M:%S:%L}</b><br/>y: <b>{point.y}</b><br/>",
        },
      },
    ],
  };
  const zpointGraph = {
    credits: {
      enabled: false,
    },
    boost: {
      useGPUTranslations: true,
      // Chart-level boost when there are more than 5 series in the chart
      seriesThreshold: 5,
    },
    chart: {
      type: "scatter",
      zoomType: "xy",
      // height: 180,
      width: 900,
    },
    title: {
      text: "Z-Axis Event Graph",
    },
    tooltip: {
      valueDecimals: 2,
    },
    xAxis: {
      title: {
        text: "",
      },
      type: "datetime",
    },
    yAxis: {
      title: {
        text: "mm/s",
      },
    },
    plotOptions: {
      scatter: {
        marker: {
          radius: 5,
          states: {
            hover: {
              enabled: false,
              //   lineColor: 'rgb(100,100,100)'
            },
          },
        },
      },
    },
    series: [
      {
        name: "Z",
        // color: "rgb(177, 205, 233)",
        data: zPointData,
        tooltip: {
          crosshairs: true,
          pointFormat:
            "x: <b>{point.x:%e:%b%Y %H:%M:%S:%L}</b><br/>y: <b>{point.y}</b><br/>",
        },
      },
    ],
  };

  const [dinXData, setDinXData] = useState<any>([]);
  const [dinYData, setDinYData] = useState<any>([]);
  const [dinZData, setDinZData] = useState<any>([]);

  const scatter_graph = {
    chart: {
      type: "scatter",
      zoomType: "xy",
      // height: 180,
      width: 500,
    },
    title: {
      text: "DIN PLOT GRAPH",
    },
    tooltip: {
      valueDecimals: 2,
    },
    xAxis: {
      title: {
        enabled: true,
        text: "Frequency [Hz]",
      },
      max: 100,
      min: 0,
    },
    yAxis: {
      title: {
        text: "Velocity [mm/s]",
      },
      max: 50,
      min: 0,
    },
    plotOptions: {
      scatter: {
        marker: {
          radius: 5,
          states: {
            hover: {
              enabled: false,
              //   lineColor: 'rgb(100,100,100)'
            },
          },
        },
      },
    },
    series: [
      {
        type: "line",
        name: "1",
        data: [
          [0, 20],
          [10, 20],
          [50, 40],
          [200, 50],
        ],
        marker: {
          enabled: false,
        },
        states: {
          hover: {
            lineWidth: 0,
          },
        },
        enableMouseTracking: false,
      },
      {
        type: "line",
        name: "2",
        color: "rgba(252, 144, 3)",
        data: [
          [0, 5],
          [10, 5],
          [50, 15],
          [100, 20],
        ],
        marker: {
          enabled: false,
        },
        states: {
          hover: {
            lineWidth: 0,
          },
        },
        enableMouseTracking: false,
      },
      {
        type: "line",
        name: "3",
        color: "rgba(252, 186, 3)",
        data: [
          [0, 3],
          [10, 3],
          [50, 8],
          [100, 10],
        ],
        marker: {
          enabled: false,
        },
        states: {
          hover: {
            lineWidth: 0,
          },
        },
        enableMouseTracking: false,
      },
      {
        name: "K1(X)",
        color: "rgba(235, 64, 52)",
        data: dinXData,
        enableMouseTracking: false,
      },
      {
        name: "K2(Y)",
        color: "rgba(52, 70, 235)",
        data: dinYData,
        enableMouseTracking: false,
      },
      {
        name: "K3(Z)",
        color: "rgba(235, 52, 104)",
        data: dinZData,
        enableMouseTracking: false,
      },
    ],
  };

  let headerGroup = (
    <ColumnGroup>
      <Row>
        <Column header="Date/Time" rowSpan={3} />
        <Column header="|MAX|" rowSpan={3} />
        <Column header="|VR|" rowSpan={3} />
        <Column header="Max Amplitudes [Unit]" colSpan={4} />
        <Column header="DOM Frequencies" colSpan={4} />
      </Row>

      <Row>
        <Column header="X" field="amplitude_X" />
        <Column header="Y" field="amplitude_Y" />
        <Column header="Z" field="amplitude_Z" />
        <Column header="X" field="frequency_X" />
        <Column header="Y" field="frequency_Y" />
        <Column header="Z" field="frequency_Z" />
      </Row>
    </ColumnGroup>
  );

  const modalClosed = () => {
    setIsModalOpen(false);
    window.close();
  };
  const renderFooter = () => {
    return (
      <div>
        <Button
          label={t("cancel")}
          icon="pi pi-times"
          onClick={modalClosed}
          className="p-button-text"
        />
        <Button
          label={t("view_report")}
          icon="pi pi-check"
          onClick={() => {
            setIsModalOpen(false);
            setViewReport(true);
            if (eventchecked) {
              setTableShown(true);
            }
          }}
          autoFocus
        />
      </div>
    );
  };

  const rowChecked = (evt: any) => {
    if (evt.target.name === "Events List") {
      setEventChecked(evt.checked);
      setTableChecked(false);
    } else {
      setEventChecked(false);
      setTableChecked(evt.checked);
    }
  };

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem("lang")!);

    let startTime, endTime;
    projectService
      .getMultipleReport(did, strtDate, edDate, projectId)
      .then(async (response) => {
        startTime = response["maxRow"]["start_time"];
        endTime = response["maxRow"]["end_time"];
        let json = {};
        let resp_json = await Promise.all(
          response["allValues"].map((resp: any) => {
            let max_arr = [resp["max_X"], resp["max_Y"], resp["max_Z"]];
            let main_max = Math.max.apply(null, max_arr);
            let freq_X =
              resp["frequency_X"] === null
                ? 0.0
                : resp["frequency_X"].toFixed(2);
            let freq_Y =
              resp["frequency_Y"] === null
                ? 0.0
                : resp["frequency_Y"].toFixed(2);
            let freq_Z =
              resp["frequency_Z"] === null
                ? 0.0
                : resp["frequency_Z"].toFixed(2);
            json = {
              did: resp["did"],
              start_time: new Date(resp["start_time"] * 1000).toLocaleString(),
              end_time: new Date(resp["end_time"] * 1000).toLocaleString(),
              vr: resp["vector_sum"],
              max_X: resp["max_X"],
              max_Y: resp["max_Y"],
              max_Z: resp["max_Z"],
              frequence_X: freq_X,
              frequence_Y: freq_Y,
              frequence_Z: freq_Z,
              main_max: main_max,
            };
            return json;
          })
        );

        const apiCalls = [
          projectService
            .getDinData(did, startTime, endTime)
            .then((response) => {
              let x_data = [
                Math.round(response["max_X"] * 100) / 100,
                response["frequence_X"],
              ];
              let y_data = [
                Math.round(response["max_Y"] * 100) / 100,
                response["frequence_Y"],
              ];
              let z_data = [
                Math.round(response["max_Z"] * 100) / 100,
                response["frequence_Z"],
              ];
              setDinXData(x_data);
              setDinYData(y_data);
              setDinZData(z_data);
            }),

          projectService
            .getVisualizationData(did, startTime, endTime)
            .then((response) => {
              let x_data, y_data, z_data;
              response.forEach((data: any) => {
                if (data["channel_X"]) {
                  const timeX = (
                    checkAbsoluteValue(data["channel_X"], data["max"]) /
                    Number(data["header_data"]["sampling_rate"])
                  ).toFixed(2);
                  const updatedTimeX = getDecimalValue(timeX);
                  setMaxTimeX(updatedTimeX);
                  const integerX = getDecimalValue(
                    Number(
                      computeIntegration(
                        data["channel_X"],
                        Number(data["descaling"]),
                        data["header_data"]["sampling_rate"]
                      )
                    )
                  );
                  setIntegrationX(integerX);
                  const differenX = getDecimalValue(
                    Number(
                      computeDifferential(
                        data["channel_X"],
                        Number(data["descaling"]),
                        data["header_data"]["sampling_rate"]
                      )
                    )
                  );
                  setDifferentialX(differenX);
                  setDeviceName(data.header_data["device_name"]);
                  setHeaderData({
                    station_name: data.header_data["station_name"],
                    client: data.header_data["client"],
                    company: data.header_data["company"],
                    location: data.header_data["location"],
                    station: data["station"],
                  });
                  setStationName(data["station"]);
                  const date = calculateDate(
                    new Date(data.start_time).getTime() / 1000
                  );
                  const eddate = calculateDate(
                    new Date(data.end_time).getTime() / 1000
                  );
                  setStrtTime(date);
                  setEndTime(eddate);
                  setDeviceId(data.did);
                  const pos = getDecimalValue(data.gps_pos);
                  setGpsPos(pos);
                  setXAxisUnit(data.unit);
                  const maxX = getDecimalValue(Number(data.max).toFixed(3));
                  setMaxX(maxX);
                  const freq_X =
                    data.frequence_X === null
                      ? ""
                      : getDecimalValue(Number(data.frequence_X));
                  setFrequenceX(freq_X);
                  x_data = data.channel_X.map((x: any, i: any) => [
                    (data.time_interval / data.channel_X.length) * i,
                    x,
                  ]);
                } else if (data["channel_Y"]) {
                  const timeY = (
                    checkAbsoluteValue(data["channel_Y"], data["max"]) /
                    Number(data["header_data"]["sampling_rate"])
                  ).toFixed(2);
                  const updatedTimeY = getDecimalValue(timeY);
                  setMaxTimeY(updatedTimeY);
                  setYAxisUnit(data.unit);
                  const integerY = getDecimalValue(
                    Number(
                      computeIntegration(
                        data["channel_Y"],
                        Number(data["descaling"]),
                        data["header_data"]["sampling_rate"]
                      )
                    )
                  );
                  setIntegrationY(integerY);
                  const differenY = getDecimalValue(
                    Number(
                      computeDifferential(
                        data["channel_Y"],
                        Number(data["descaling"]),
                        data["header_data"]["sampling_rate"]
                      )
                    )
                  );
                  setDifferentialY(differenY);
                  const maxY = getDecimalValue(Number(data.max).toFixed(3));
                  setMaxY(maxY);
                  const freq_Y =
                    data.frequence_Y === null
                      ? ""
                      : getDecimalValue(Number(data.frequence_Y));
                  setFrequenceY(freq_Y);
                  y_data = data.channel_Y.map((x: any, i: any) => [
                    (data.time_interval / data.channel_Y.length) * i,
                    x,
                  ]);
                } else if (data["channel_Z"]) {
                  setZAxisUnit(data.unit);
                  const timeZ = (
                    checkAbsoluteValue(data["channel_Z"], data["max"]) /
                    Number(data["header_data"]["sampling_rate"])
                  ).toFixed(2);
                  const updatedTimeZ = getDecimalValue(timeZ);
                  setMaxTimeZ(updatedTimeZ);
                  setZAxisUnit(data.unit);
                  const integerZ = getDecimalValue(
                    Number(
                      computeIntegration(
                        data["channel_Z"],
                        Number(data["descaling"]),
                        data["header_data"]["sampling_rate"]
                      )
                    )
                  );
                  setIntegrationZ(integerZ);
                  const differenZ = getDecimalValue(
                    Number(
                      computeDifferential(
                        data["channel_Z"],
                        Number(data["descaling"]),
                        data["header_data"]["sampling_rate"]
                      )
                    )
                  );
                  setDifferentialZ(differenZ);
                  const maxZ = getDecimalValue(Number(data.max).toFixed(3));
                  setMaxZ(maxZ);
                  const freq_Z =
                    data.frequence_Z === null
                      ? ""
                      : getDecimalValue(Number(data.frequence_Z));
                  setFrequenceZ(freq_Z);
                  z_data = data.channel_Z.map((x: any, i: any) => [
                    (data.time_interval / data.channel_Z.length) * i,
                    x,
                  ]);
                }
              });
              setXdata(x_data);
              setYdata(y_data);
              setZdata(z_data);
            }),

          projectService
            .getVectorSumData(did, startTime, endTime)
            .then((response: any) => {
              let data = response.vector_sum.map((x: any, i: any) => [
                (response.time_interval / response.vector_sum.length) * i,
                x,
              ]);
              setVectorSumData(data);
            }),

          projectService
            .getPointVisualizationData(did, strtDate, edDate)
            .then((response) => {
              let xPoint_data = response.map((x: any, i: any) => [
                new Date(x.start_time).getTime() +
                  (x.time_interval / x.data_length) * i * 1000,
                x["max_X"],
              ]);
              let yPoint_data = response.map((x: any, i: any) => [
                new Date(x.start_time).getTime() +
                  (x.time_interval / x.data_length) * i * 1000,
                x["max_Y"],
              ]);
              let zPoint_data = response.map((x: any, i: any) => [
                new Date(x.start_time).getTime() +
                  (x.time_interval / x.data_length) * i * 1000,
                x["max_Z"],
              ]);
              setXPointdata(xPoint_data);
              setYPointdata(yPoint_data);
              setZPointdata(zPoint_data);
            }),
        ];

        // Handle all API calls
        Promise.all(apiCalls).then(() => {
          if (response["allValues"].length <= 500) {
            setDisable(false);
            setAllData(resp_json);
          }
          setTimeout(window.print, tableShown ? 8000 : 2000);
          window.addEventListener("afterprint", () => window.close());
        });
      });

    if (viewReport) {
      projectService
        .getMultipleReport(did, strtDate, edDate, projectId)
        .then(async (response) => {
          startTime = response["maxRow"]["start_time"];
          endTime = response["maxRow"]["end_time"];
          let json = {};
          let resp_json = await Promise.all(
            response["allValues"].map((resp: any) => {
              // resp.map((val: any) => {
              let max_arr = [resp["max_X"], resp["max_Y"], resp["max_Z"]];
              let main_max = Math.max.apply(null, max_arr);
              let freq_X, freq_Y, freq_Z;
              if (resp["frequency_X"] === null) {
                freq_X = 0.0;
              } else {
                freq_X = resp["frequency_X"].toFixed(2);
              }
              if (resp["frequency_Y"] === null) {
                freq_Y = 0.0;
              } else {
                freq_Y = resp["frequency_Y"].toFixed(2);
              }
              if (resp["frequency_Z"] === null) {
                freq_Z = 0.0;
              } else {
                freq_Z = resp["frequency_Z"].toFixed(2);
              }
              json = {
                did: resp["did"],
                start_time: new Date(
                  resp["start_time"] * 1000
                ).toLocaleString(),
                end_time: new Date(resp["end_time"] * 1000).toLocaleString(),
                vr: resp["vector_sum"],
                max_X: resp["max_X"],
                max_Y: resp["max_Y"],
                max_Z: resp["max_Z"],
                frequence_X: freq_X,
                frequence_Y: freq_Y,
                frequence_Z: freq_Z,
                main_max: main_max,
              };
              // });
              return json;
            })
          );

          if (response["allValues"].length <= 500) {
            setDisable(false);
            setAllData(resp_json);
          }

          projectService
            .getDinData(did, startTime, endTime)
            .then((response) => {
              let x_data: any;
              let y_data: any;
              let z_data: any;

              x_data = [
                Math.round(response["max_X"] * 100) / 100,
                response["frequence_X"],
              ];
              y_data = [
                Math.round(response["max_Y"] * 100) / 100,
                response["frequence_Y"],
              ];
              z_data = [
                Math.round(response["max_Z"] * 100) / 100,
                response["frequence_Z"],
              ];
              setDinXData(x_data);
              setDinYData(y_data);
              setDinZData(z_data);
            });

          projectService
            .getVisualizationData(did, startTime, endTime)
            .then((response) => {
              let x_data: any;
              let y_data: any;
              let z_data: any;
              let freq_X: any, freq_Y: any, freq_Z: any;

              /**  FOR TIME SECONDS **/
              response.map((data: any) => {
                if (data["channel_X"]) {
                  const timeX = (
                    checkAbsoluteValue(data["channel_X"], data["max"]) /
                    Number(data["header_data"]["sampling_rate"])
                  ).toFixed(2);
                  const updatedTimeX: any = getDecimalValue(timeX);
                  setMaxTimeX(updatedTimeX);
                  const integerX: any = getDecimalValue(
                    Number(
                      computeIntegration(
                        data["channel_X"],
                        Number(data["descaling"]),
                        data["header_data"]["sampling_rate"]
                      )
                    )
                  );
                  setIntegrationX(integerX);
                  const differenX: any = getDecimalValue(
                    Number(
                      computeDifferential(
                        data["channel_X"],
                        Number(data["descaling"]),
                        data["header_data"]["sampling_rate"]
                      )
                    )
                  );
                  setDifferentialX(differenX);
                  setDeviceName(data.header_data["device_name"]);
                  setHeaderData({
                    station_name: data.header_data["station_name"],
                    client: data.header_data["client"],
                    company: data.header_data["company"],
                    location: data.header_data["location"],
                    station: data["station"],
                  });
                  setStationName(data["station"]);
                  const date = calculateDate(
                    new Date(data.start_time).getTime() / 1000
                  );
                  const eddate = calculateDate(
                    new Date(data.end_time).getTime() / 1000
                  );
                  setStrtTime(date);
                  setEndTime(eddate);
                  setDeviceId(data.did);
                  const pos: any = getDecimalValue(data.gps_pos);
                  setGpsPos(pos);
                  setXAxisUnit(data.unit);
                  const maxX: any = getDecimalValue(
                    Number(data.max).toFixed(3)
                  );
                  setMaxX(maxX);
                  if (data.frequence_X === null) {
                    freq_X = "";
                  } else {
                    freq_X = getDecimalValue(Number(data.frequence_X));
                  }
                  setFrequenceX(freq_X);
                  x_data = data.channel_X.map((x: any, i: any) => [
                    (data.time_interval / data.channel_X.length) * i,
                    x,
                  ]);
                } else if (data["channel_Y"]) {
                  const timeY = (
                    checkAbsoluteValue(data["channel_Y"], data["max"]) /
                    Number(data["header_data"]["sampling_rate"])
                  ).toFixed(2);
                  const updatedTimeY: any = getDecimalValue(timeY);
                  setMaxTimeY(updatedTimeY);
                  setYAxisUnit(data.unit);
                  const integerY: any = getDecimalValue(
                    Number(
                      computeIntegration(
                        data["channel_Y"],
                        Number(data["descaling"]),
                        data["header_data"]["sampling_rate"]
                      )
                    )
                  );
                  setIntegrationY(integerY);
                  const differenY: any = getDecimalValue(
                    Number(
                      computeDifferential(
                        data["channel_Y"],
                        Number(data["descaling"]),
                        data["header_data"]["sampling_rate"]
                      )
                    )
                  );
                  setDifferentialY(differenY);
                  const maxY: any = getDecimalValue(
                    Number(data.max).toFixed(3)
                  );
                  setMaxY(maxY);
                  if (data.frequence_Y === null) {
                    freq_Y = "";
                  } else {
                    freq_Y = getDecimalValue(Number(data.frequence_Y));
                  }
                  setFrequenceY(freq_Y);
                  setYAxisUnit(data.unit);
                  y_data = data.channel_Y.map((x: any, i: any) => [
                    (data.time_interval / data.channel_Y.length) * i,
                    x,
                  ]);
                } else if (data["channel_Z"]) {
                  setZAxisUnit(data.unit);
                  const timeZ = (
                    checkAbsoluteValue(data["channel_Z"], data["max"]) /
                    Number(data["header_data"]["sampling_rate"])
                  ).toFixed(2);
                  const updatedTimeZ: any = getDecimalValue(timeZ);
                  setMaxTimeZ(updatedTimeZ);
                  setZAxisUnit(data.unit);
                  const integerZ: any = getDecimalValue(
                    Number(
                      computeIntegration(
                        data["channel_Z"],
                        Number(data["descaling"]),
                        data["header_data"]["sampling_rate"]
                      )
                    )
                  );
                  setIntegrationZ(integerZ);
                  const differenZ: any = getDecimalValue(
                    Number(
                      computeDifferential(
                        data["channel_Z"],
                        Number(data["descaling"]),
                        data["header_data"]["sampling_rate"]
                      )
                    )
                  );
                  setDifferentialZ(differenZ);
                  const maxZ: any = getDecimalValue(
                    Number(data.max).toFixed(3)
                  );
                  setMaxZ(maxZ);
                  if (data.frequence_Z === null) {
                    freq_Z = "";
                  } else {
                    freq_Z = getDecimalValue(Number(data.frequence_Z));
                  }
                  setFrequenceZ(freq_Z);

                  z_data = data.channel_Z.map((x: any, i: any) => [
                    (data.time_interval / data.channel_Z.length) * i,
                    x,
                  ]);
                }
              });
              setXdata(x_data);
              setYdata(y_data);
              setZdata(z_data);
            });

          projectService
            .getVectorSumData(did, startTime, endTime)
            .then((response: any) => {
              let data: any;
              data = response.vector_sum.map((x: any, i: any) => [
                (response.time_interval / response.vector_sum.length) * i,
                x,
              ]);

              setVectorSumData(data);
            });

          projectService
            .getPointVisualizationData(did, strtDate, edDate)
            .then((response) => {
              let xPoint_data: any;
              let yPoint_data: any;
              let zPoint_data: any;

              xPoint_data = response.map((x: any, i: any) => [
                new Date(x.start_time).getTime() +
                  (x.time_interval / x.data_length) * i * 1000,
                x["max_X"],
              ]);
              yPoint_data = response.map((x: any, i: any) => [
                new Date(x.start_time).getTime() +
                  (x.time_interval / x.data_length) * i * 1000,
                x["max_Y"],
              ]);
              zPoint_data = response.map((x: any, i: any) => [
                new Date(x.start_time).getTime() +
                  (x.time_interval / x.data_length) * i * 1000,
                x["max_Z"],
              ]);
              setXPointdata(xPoint_data);
              setYPointdata(yPoint_data);
              setZPointdata(zPoint_data);

              // setTimeout(window.print, tableShown ? 30000 : 20000);
              // window.addEventListener("afterprint", (event) => {
              //   window.close();
              // });
            });
        });
    }
  }, [viewReport, i18n.language]);
  return (
    <>
      <Dialog
        header={t("select_event")}
        visible={isModalOpen}
        footer={renderFooter()}
        onHide={modalClosed}
      >
        <div className="field-checkbox">
          <Checkbox
            inputId="event-list"
            checked={eventchecked}
            name="Events List"
            onChange={(e) => {
              rowChecked(e);
            }}
            disabled={disable}
          />
          <label htmlFor="event-list">{t("download_event_list")}</label>
        </div>

        <div className="field-checkbox">
          <Checkbox
            inputId="no-list"
            checked={tablechecked}
            name="No Events List"
            onChange={(e) => rowChecked(e)}
          />
          <label htmlFor="no-list">{t("downlaod_without_event_list")}</label>
        </div>
      </Dialog>

      {viewReport ? (
        <>
          <div>
            <img
              alt="DMT-Logo"
              src="./images/logo.png"
              className="mr-2"
              style={{
                float: "right",
                paddingRight: "40px",
                height: "32px",
              }}
            />
          </div>
          <h2 style={{ textAlign: "center", paddingTop: "10px" }}>
            {t("compliance_report")}
          </h2>

          <div className="flex justify-content-between">
            <div className="flex">
              <p className="my-1 text-bold">{t("start_time")}: </p>
              <p className="my-1 ml-2">
                {" "}
                {strtTime} [{getTimeZoneName()}]
              </p>
            </div>
            <div className="flex">
              <p className="my-1 text-bold">{t("end_time")}: </p>
              <p className="my-1 ml-2">
                {" "}
                {edTime} [{getTimeZoneName()}]
              </p>
            </div>
          </div>
          <div className="flex justify-content-between messinfo">
            <div>
              <h4>{t("measurement_information")}</h4>
              <div className="flex">
                <div className="flex">
                  <p className="my-1 field">{t("station_name")}:</p>
                  <p className="ml-4 my-1"> {stationName}</p>
                </div>
              </div>
              <div className="flex">
                <div className="flex">
                  <p className="my-1 field">{t("company")}:</p>
                  <p className="ml-4 my-1">{headerData["client"]}</p>
                </div>
              </div>
              <div className="flex">
                <div className="flex">
                  <p className="my-1 field">{t("client")}:</p>
                  <p className="ml-4 my-1">{headerData["company"]}</p>
                </div>
              </div>
              <div className="flex">
                <div className="flex">
                  <p className="my-1 field"> {t("gps_position")}:</p>
                  <p className="ml-4 my-1">{gpsPos}</p>
                </div>
              </div>
            </div>
            <div>
              <h4>
                {t("devices")} {t("information")}:
              </h4>
              <div className="flex">
                <div className="flex">
                  <p className="my-1 field">Station:</p>
                  <p className="ml-4 my-1">Vipa 130</p>
                </div>
              </div>
              <div className="flex">
                <div className="flex">
                  <p className="my-1 field">Auftraggeber:</p>
                  <p className="ml-4 my-1">Vipa 130</p>
                </div>
              </div>
              <div className="flex">
                <div className="flex">
                  <p className="my-1 field">Firma:</p>
                  <p className="ml-4 my-1">Vipa 130</p>
                </div>
              </div>
              <div className="flex">
                <div className="flex">
                  <p className="my-1 field">Station:</p>
                  <p className="ml-4 my-1">Vipa 130</p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-content-end mt-3">
            <HighchartsReact highcharts={Highcharts} options={scatter_graph} />
          </div>

          <div className="grid">
            <div className="col-md-2 ml-8">
              <h4>{t("channel_name")}</h4>
            </div>
            <div className="col-md-2 ml-4">
              <h4>|{t("maxima")}|</h4>
            </div>
            <div className="col-md-2 ml-4">
              <h4>{t("time_maxima")}</h4>
            </div>
            <div className="col-md-2 ml-4">
              <h4>KBFmax</h4>
            </div>
            <div className="col-md-2 ml-4">
              <h4>FFT {t("frequency")}</h4>
            </div>
            <div className="col-md-2 ml-4">
              <h4>{t("peak_displacement")}</h4>
            </div>
            <div className="col-md-2 ml-4">
              <h4>{t("peak_acceleration")}</h4>
            </div>
          </div>

          <div className="grid">
            <p className="">K1(X)</p>
            <div className="col-md-2 ml-4">
              <p className="ml-6">: X</p>
            </div>
            <div className="col-md-2 ml-4">
              <p className="ml-7">
                {maxX} {xAxisUnit}
              </p>
            </div>
            <div className="col-md-2 ml-4">
              <p className="ml-5">{maxTimeX} s</p>
            </div>
            <div className="col-md-2 ml-4">
              <p className="ml-6">---</p>
            </div>
            <div className="col-md-2 ml-4">
              <p className="ml-6">{frequenceX} Hz</p>
            </div>
            <div className="col-md-2 ml-4">
              <p className="ml-7">{integrationX} µm</p>
            </div>
            <div className="col-md-2 ml-4">
              <p className="ml-8">{differentialX} mm/s²</p>
            </div>
          </div>

          <div className="grid">
            <p className="">K1(Y)</p>
            <div className="col-md-2 ml-4">
              <p className="ml-6">: Y</p>
            </div>
            <div className="col-md-2 ml-4">
              <p className="ml-7">
                {maxY} {yAxisUnit}
              </p>
            </div>
            <div className="col-md-2 ml-4">
              <p className="ml-5">{maxTimeY} s</p>
            </div>
            <div className="col-md-2 ml-4">
              <p className="ml-6">---</p>
            </div>
            <div className="col-md-2 ml-4">
              <p className="ml-6">{frequenceY} Hz</p>
            </div>
            <div className="col-md-2 ml-4">
              <p className="ml-7">{integrationY} µm</p>
            </div>
            <div className="col-md-2 ml-4">
              <p className="ml-8">{differentialY} mm/s²</p>
            </div>
          </div>

          <div className="grid">
            <p className="">K1(Z)</p>
            <div className="col-md-2 ml-4">
              <p className="ml-6">: Z</p>
            </div>
            <div className="col-md-2 ml-4">
              <p className="ml-7">
                {maxZ} {zAxisUnit}
              </p>
            </div>
            <div className="col-md-2 ml-4">
              <p className="ml-5">{maxTimeZ} s</p>
            </div>
            <div className="col-md-2 ml-4">
              <p className="ml-6">---</p>
            </div>
            <div className="col-md-2 ml-4">
              <p className="ml-6">{frequenceZ} Hz</p>
            </div>
            <div className="col-md-2 ml-4">
              <p className="ml-7">{integrationZ} µm</p>
            </div>
            <div className="col-md-2 ml-4">
              <p className="ml-8">{differentialZ} mm/s²</p>
            </div>
          </div>

          <HighchartsReact highcharts={Highcharts} options={graph_x} />
          <HighchartsReact highcharts={Highcharts} options={graph_y} />
          <HighchartsReact highcharts={Highcharts} options={graph_z} />
          <HighchartsReact highcharts={Highcharts} options={vector_sum_graph} />
          <h3 className="ml-4 mt-4  text-bold">{t("graphical_overview")}</h3>
          <HighchartsReact highcharts={Highcharts} options={xpointGraph} />
          <HighchartsReact highcharts={Highcharts} options={ypointGraph} />
          <HighchartsReact highcharts={Highcharts} options={zpointGraph} />

          {tableShown ? (
            <DataTable
              className="all-data-table"
              value={allData}
              lazy
              headerColumnGroup={headerGroup}
              responsiveLayout="scroll"
              rowHover
            >
              <Column field="start_time" />
              <Column field="main_max" />
              <Column field="vr" />
              <Column field="max_X" />
              <Column field="max_Y" />
              <Column field="max_Z" />
              <Column field="frequence_X" />
              <Column field="frequence_Y" />
              <Column field="frequence_Z" />
            </DataTable>
          ) : (
            <></>
          )}
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default EventReport;
